/*
 * @Author: zhechuan.Wang
 * @Date: 2023-12-07 14:43:32
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2023-12-08 17:38:11
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\api\cardProject.js
 */
import axiosApi from './AxiosApi.js';
const baseUrl = '/anno/cardProject';

const [methodGet, methodPost, methodPut, methodDelete] = ['GET', 'POST', 'PUT', 'DELETE'];

export default {
  // 补贴项目公示列表
  getList(data) {
    return axiosApi({
      method: methodPost,
      url: `${baseUrl}/list`,
      data,
    });
  },
  // 首页表尾统计数据
  getCurrent(data) {
    return axiosApi({
      method: methodPost,
      url: '/anno/cardStats/getCurrent',
      data,
    });
  },
  // 补贴项目发放信息
  getCardReqInfo(data) {
    return axiosApi({
      method: methodPost,
      url: '/anno/cardReq/getCardReqInfo',
      data,
    });
  },
  // 补贴项目发放信息明细
  getCardReqInfoDetail(data) {
    return axiosApi({
      method: methodPost,
      url: '/anno/cardReq/getCardReqInfoDetail',
      data,
    });
  },
};
